import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import { handleError } from './user';
import formatDate from '../services/formatDate';
import mixpanelConstants from '../constants/mixpanel';
import { setnursedashboard } from './nurseshift';
import constants from '../services/constants';

export const setShiftDetail = createAction('SET_SHIFT_DETAIL');
export const setShiftReq = createAction('SET_SHIFT_REQ');
export const setReqCustomeFields = createAction('SET_REQ_CUSTOME_FIELDS');
export const setReqDetails = createAction('SET_REQ_DETAILS');
export const setUserID = createAction('SET_USER_ID');
export const setLat = createAction('SET_LAT');
export const setLng = createAction('SET_LNG');
export const setUpcomingShiftById = createAction('SET_UPCOMING_SHIFTBYID');
export const setCheckoutDetail = createAction('SET_CHECKOUT_DETAIL');
export const setIsFetchingBookmarkData = createAction('SET_IS_FETCHING_BOOKMARK_DATA');
export const setDisableApplyBtn = createAction('SET_DISABLE_APPLYBTN');
export const setOpenWithdrawReasonPopup = createAction('SET_OPEN_WITHDRAW_REASON_POPUP');
export const setOpenCalloutReasonPopup = createAction('SET_OPEN_CALLOUT_REASON_POPUP');
export const setReasonValue = createAction('SET_REASON_VALUE');
export const setReasons = createAction('SET_REASONS');

const initialState = {
	checkoutDetails: {},
	disableApplyBtn: false,
	isFetchingBookmarkData: false,
	lattd: '',
	lngtd: '',
	openCalloutReasonPopup: false,
	openWithdrawReasonPopup: false,
	reasons: [],
	reasonValue: '',
	reqCustomFields: [],
	reqDocFileDetails: [],
	requirementDetails: [],
	shiftDetails: {},
	shiftRequirements: [],
	upcomingShiftById: {},
	user_id: 0 //calloutReason
};

export default handleActions(
	{
		SET_CHECKOUT_DETAIL: (state, action) => ({ ...state, checkoutDetails: action.payload }),
		SET_DISABLE_APPLYBTN: (state, action) => ({ ...state, disableApplyBtn: action.payload }),
		SET_IS_FETCHING_BOOKMARK_DATA: (state, action) => ({ ...state, isFetchingBookmarkData: action.payload }),
		SET_LAT: (state, action) => ({ ...state, lattd: action.payload }),
		SET_LNG: (state, action) => ({ ...state, lngtd: action.payload }),
		SET_OPEN_CALLOUT_REASON_POPUP: (state, action) => ({ ...state, openCalloutReasonPopup: action.payload }),
		SET_OPEN_WITHDRAW_REASON_POPUP: (state, action) => ({ ...state, openWithdrawReasonPopup: action.payload }),
		SET_REASON_VALUE: (state, action) => ({ ...state, reasonValue: action.payload }),
		SET_REASONS: (state, action) => ({ ...state, reasons: action.payload }),
		SET_REQ_CUSTOME_FIELDS: (state, action) => ({ ...state, reqCustomFields: action.payload }),
		SET_REQ_DETAILS: (state, action) => ({ ...state, requirementDetails: action.payload }),
		SET_SHIFT_DETAIL: (state, action) => ({ ...state, shiftDetails: action.payload }),
		SET_SHIFT_REQ: (state, action) => ({ ...state, shiftRequirements: action.payload }),
		SET_UPCOMING_SHIFTBYID: (state, action) => ({ ...state, upcomingShiftById: action.payload }),
		SET_USER_ID: (state, action) => ({ ...state, user_id: action.payload })
	},
	initialState
);

export const getShift = (id) => {
	return function (dispatch) {
		dispatch(setIsFetchingBookmarkData(true));
		Agent.getShiftDetail(id).then((response) => {
			if (response.ok) {
				dispatch(setIsFetchingBookmarkData(false));
				dispatch(setShiftDetail(response.data));
			} else {
				dispatch(setIsFetchingBookmarkData(false));
				dispatch(handleError(response));
			}
		});
	};
};

export const getShiftRequirements = (id) => {
	return function (dispatch) {
		Agent.getShiftRequirements(id).then((response) => {
			if (response.ok) {
				dispatch(setShiftReq(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const fetchRequirementToAdd = (req_id) => {
	return function (dispatch) {
		Agent.getUserRequirementToAdd(req_id).then((response) => {
			if (response.ok) {
				dispatch(setReqDetails(response.data));

				// Custom field generation
				let tempCustomFields = [];
				if (response.data.fields != undefined) {
					response.data.fields.map((f) => {
						tempCustomFields.push({
							field_name: f.field_name,
							field_type: f.data_type,
							field_value:
								eval('f.val_' + f.data_type) != null
									? f.data_type == 'date'
										? formatDate.serverDateToMmDdYy(eval('f.val_' + f.data_type))
										: eval('f.val_' + f.data_type)
									: '',
							id: f.id,
							user_req_field_id: f.user_req_field_id
						});
					});
				}
				dispatch(setReqCustomeFields(tempCustomFields));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const calloutShift = (id) => {
	return function (dispatch, getState) {
		const { reasonValue } = getState().shiftdetail;
		Agent.calloutShift(id, reasonValue).then((response) => {
			if (response.ok) {
				let shiftDetails = getState().shiftdetail.shiftDetails;
				mixpanel.track(mixpanelConstants.CANCEL_SHIFT, {
					address: shiftDetails.address,
					city: shiftDetails.city,
					organization: shiftDetails.organization,
					organizationId: shiftDetails.organization_id,
					roleList: shiftDetails.role_list,
					shiftId: id
				});
				dispatch(getShift(id));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const withdrawShift = (id) => {
	return function (dispatch, getState) {
		const { reasonValue } = getState().shiftdetail;
		Agent.withdrawShift(id, reasonValue).then((response) => {
			if (response.ok) {
				let shiftDetails = getState().shiftdetail.shiftDetails;
				mixpanel.track(mixpanelConstants.WITHDRAW_SHIFT, {
					address: shiftDetails.address,
					city: shiftDetails.city,
					organization: shiftDetails.organization,
					organizationId: shiftDetails.organization_id,
					roleList: shiftDetails.role_list,
					shiftId: id
				});
				dispatch(getShift(id));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const applyshift = (id, calledFrom) => {
	return function (dispatch, getState) {
		const { nursedashboardList } = getState().nurseshift;
		let shiftIdx = -1;

		Agent.applyShift(id).then((response) => {
			if (response.ok) {
				let shiftDetails = getState().shiftdetail.shiftDetails;
				let mixpanelConstant = '';

				if (calledFrom == constants.ISRECOMMENDEDSHIFT) {
					mixpanelConstant = mixpanelConstants.APPLY_SHIFT_RECOMMENDATION;
				} else if (calledFrom == constants.FROMSHIFTLIST) {
					mixpanelConstant = mixpanelConstants.APPLY_SHIFT_DASHBOARD;
				} else if (calledFrom == constants.FROMSHIFTDETAIL) {
					mixpanelConstant = mixpanelConstants.APPLY_SHIFT_DETAIL;
				} else if (calledFrom == constants.ISRECOMMENDEDSHIFTDETAIL) {
					mixpanelConstant = mixpanelConstants.APPLY_SHIFT_RECOMMENDATION_FROM_Detail;
				} else if (calledFrom == constants.ISRECOMMENDEDSHIFTLIST) {
					mixpanelConstant = mixpanelConstants.APPLY_SHIFT_RECOMMENDATION_FROM_LIST;
				}

				mixpanel.track(mixpanelConstant, {
					address: shiftDetails.address,
					city: shiftDetails.city,
					organization: shiftDetails.organization,
					organizationId: shiftDetails.organization_id,
					roleList: shiftDetails.role_list,
					shiftDate: shiftDetails.shift_date,
					shiftEnd: shiftDetails.shift_end,
					shiftId: id,
					shiftStart: shiftDetails.shift_start
				});
				dispatch(getShift(id));

				//Removing recently applied shift from the open shift list array

				if (calledFrom === constants.ISRECOMMENDEDSHIFT) {
					shiftIdx = nursedashboardList.recommended_shifts.findIndex((shift) => shift.shift_id == id);
					nursedashboardList.recommended_shifts.splice(shiftIdx, 1);
					dispatch(setnursedashboard(JSON.parse(JSON.stringify(nursedashboardList))));
				} else {
					shiftIdx = nursedashboardList.shifts.findIndex((shift) => shift.shift_id == id);
					nursedashboardList.shifts.splice(shiftIdx, 1);
					dispatch(setnursedashboard(JSON.parse(JSON.stringify(nursedashboardList))));
				}
				alert('Successfully applied for shift');
			} else {
				if (response.status == 400) {
					alert(response.data);
				} else {
					dispatch(handleError(response));
				}
			}
		});
	};
};

export const getReasons = (type) => {
	return function (dispatch) {
		Agent.getDNRReason(type).then((response) => {
			if (response.ok) {
				dispatch(setReasons(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
